import type {PepPublicRole, PepRelationship} from '@sollapay/enums';

export const YEAR_MONTH_RE = /^\d{4}-\d{2}$/;

export interface PepPartyFormValues {
  relationship: PepRelationship | '';
  fullName: string;
  countryOfOffice: string;
  publicRole: PepPublicRole | '';
  stillInRole: boolean;
  roleStartMonth: string;
  roleEndMonth: string;
  sourceOfWealth: string;
}

export interface PepFormValues {
  isPep: boolean;
  parties: PepPartyFormValues[];
}

export const EMPTY_PEP_PARTY: PepPartyFormValues = {
  relationship: '',
  fullName: '',
  countryOfOffice: '',
  publicRole: '',
  stillInRole: true,
  roleStartMonth: '',
  roleEndMonth: '',
  sourceOfWealth: ''
};

/** True when all required fields are filled — used for tab completion icons. */
export const isPepPartyComplete = (
  party: PepPartyFormValues,
  {isCorporate}: {isCorporate: boolean}
): boolean => {
  if (isCorporate && !party.fullName.trim()) return false;
  if (!party.countryOfOffice.trim()) return false;
  if (!party.publicRole) return false;
  if (!party.sourceOfWealth.trim()) return false;
  if (!YEAR_MONTH_RE.test(party.roleStartMonth)) return false;
  if (isCorporate && !party.relationship) return false;
  if (!party.stillInRole && !YEAR_MONTH_RE.test(party.roleEndMonth)) return false;
  return true;
};
